/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Deep_P2Inputs */

const en_to_yaml_deep_p2 = /** @type {(inputs: To_Yaml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This converter emits quoted strings for any value that a looser reader could coerce. The JSON string "yes" comes out as the quoted YAML scalar with quotes intact, and so does "no". The same protection applies to version numbers: the string "1.10" is quoted, because unquoted it would read as the number 1.1 and lose the trailing zero. If you see quotes in the output where you did not expect them, that is the converter defending the value, not adding noise.`)
};

const ko_to_yaml_deep_p2 = /** @type {(inputs: To_Yaml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 변환기는 느슨한 리더가 강제 변환할 수 있는 값이라면 인용된 문자열로 출력합니다. JSON 문자열 "yes"는 인용부호가 그대로 살아 있는 YAML 스칼라로 나오며 "no"도 그렇습니다. 같은 보호가 버전 번호에도 적용됩니다. 문자열 "1.10"은 인용됩니다. 인용하지 않으면 숫자 1.1로 읽혀 뒤의 0을 잃기 때문입니다. 예상하지 않은 곳에 인용부호가 보이면, 그것은 변환기가 잡음을 더한 것이 아니라 값을 지키고 있는 것입니다.`)
};

const ja_to_yaml_deep_p2 = /** @type {(inputs: To_Yaml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この変換器は、緩いリーダが強制変換しうる値を引用付きの文字列として出力します。JSON の文字列 "yes" は引用符が残った YAML スカラーとして出て、"no" も同様です。同じ保護がバージョン番号にも及びます。文字列 "1.10" は引用されます。引用しないと数値 1.1 として読まれ、末尾のゼロを失うからです。予期しない場所に引用符が見えたら、それは変換器がノイズを加えたのではなく値を守っているのです。`)
};

/**
* | output |
* | --- |
* | "This converter emits quoted strings for any value that a looser reader could coerce. The JSON string \"yes\" comes out as the quoted YAML scalar with quotes in..." |
*
* @param {To_Yaml_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_deep_p2 = /** @type {((inputs?: To_Yaml_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_deep_p2(inputs)
	if (locale === "ko") return ko_to_yaml_deep_p2(inputs)
	return ja_to_yaml_deep_p2(inputs)
});